import { combineEpics, ofType } from 'redux-observable'
import { EMPTY, of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import {
  fetchGroupSettingsDataError,
  fetchGroupSettingsDataSuccess,
  saveGroupSettingsError,
  saveGroupSettingsSuccess,
  saveInfoFormError,
  saveInfoFormSuccess,
} from './actions'
import {
  FETCH_SETTINGS_REQUEST_ASYNC,
  SAVE_INFO_FORM_ASYNC,
  SAVE_SETTINGS_REQUEST_ASYNC,
} from './constants'

const saveInfoFormDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SAVE_INFO_FORM_ASYNC.INITIATE),
    mergeMap(() => {
      const state = state$.value
      const groupsettings = state.groupsettings

      if (!groupsettings?.wizard?.data) {
        return EMPTY
      }

      return api.groupSettings
        .saveInfoForm(state.partnerOptions.selectedCompany?.value, {
          name: groupsettings.wizard.data.name,
          description: groupsettings.wizard.data.description,
          id: groupsettings.wizard.data.id,
        })
        .pipe(
          map((response) => saveInfoFormSuccess(response?.response)),
          catchError((error) => of(epicsErrorHandler(saveInfoFormError, error, [400, 403, 404]))),
          takeUntil(action$.pipe(ofType(FETCH_SETTINGS_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

const fetchGroupSettingsDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(FETCH_SETTINGS_REQUEST_ASYNC.INITIATE, SAVE_INFO_FORM_ASYNC.SUCCESS),
    mergeMap(() => {
      const state = state$.value
      const groupsettings = state.groupsettings

      if (!groupsettings?.wizard?.data?.id) {
        return EMPTY
      }

      return api.groupSettings
        .getGroupSettingsData(
          state.partnerOptions.selectedCompany?.value,
          groupsettings.wizard.data.id
        )
        .pipe(
          map((response) => fetchGroupSettingsDataSuccess(response)),
          catchError((error) =>
            of(epicsErrorHandler(fetchGroupSettingsDataError, error, [400, 403, 404]))
          ),
          takeUntil(action$.pipe(ofType(FETCH_SETTINGS_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

const updateGroupSettingsDataEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SAVE_SETTINGS_REQUEST_ASYNC.INITIATE),
    mergeMap(() => {
      const state = state$.value
      const groupsettings = state.groupsettings

      return api.groupSettings
        .updateGroupSettingsData(state.partnerOptions.selectedCompany?.value, {
          groupSettingsId: groupsettings.wizard.data.id,
          incidentResponse: state.settings.incidentResponse.self.data,
          impersonationProtection: state.settings.mailboxProtection.self.data,
          landingPages: state.settings.mailboxProtection.landings.data,
          endUserAlerts: groupsettings.wizard.endUserAlerts,
          notificationsLogoTemplate:
            state.settings.notifications.logo.data.notificationsLogoTemplate,
          isDefault: groupsettings.wizard.isDefault,
        })
        .pipe(
          map((response) => saveGroupSettingsSuccess(response)),
          catchError((error) =>
            of(epicsErrorHandler(saveGroupSettingsError, error, [400, 403, 404]))
          ),
          takeUntil(action$.pipe(ofType(SAVE_SETTINGS_REQUEST_ASYNC.CANCEL)))
        )
    })
  )

export default combineEpics(
  saveInfoFormDataEpic,
  fetchGroupSettingsDataEpic,
  updateGroupSettingsDataEpic
)
